import React, { useEffect, useState } from "react";
import { Container, Row, Col, Table, Card, Form } from "react-bootstrap";
import { collection, getDocs, query, where } from "firebase/firestore";
import { useLocation, useHistory } from "react-router-dom";
import { db } from "../firebase/firebase";
import "../css/userPage.css";
import Autocomplete from "components/AutoComplete";
const logo = require("../assets/sphera.png");
const user_iwd = require("../assets/img/user_iwd.png");

const cardBodyStyle = {
  display: "flex",
  alignItems: "center",
  border: "1px solid #CE9136",
  borderRadius: "10px",
};

const UserReferent = () => {
  const [users, setUsers] = useState([]);
  const [referentInfo, setReferentInfo] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [companies, setCompanies] = useState([]);

  const location = useLocation();
  const history = useHistory();
  const urlUserId = new URLSearchParams(location.search).get("userId");
  
  // Si pas d'userId dans l'URL, utiliser l'ID de l'utilisateur connecté
  const currentUserId = localStorage.getItem("userIdStorage");
  const userRole = localStorage.getItem("role");
  const userId = urlUserId || currentUserId;

  useEffect(() => {
    const fetchReferentInfo = async () => {
      try {
        const referentDoc = await getDocs(
          query(collection(db, "users"), where("__name__", "==", userId))
        );
        if (!referentDoc.empty) {
          setReferentInfo(referentDoc.docs[0].data());
        }
      } catch (error) {
        console.error("Erreur lors de la récupération du référent: ", error);
      }
    };

    const fetchUsers = async () => {
      try {
        const q = query(
          collection(db, "users"),
          where("referentId", "==", userId)
        );
        const querySnapshot = await getDocs(q);
        const usersData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setUsers(usersData);
        setFilteredUsers(usersData);
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des utilisateurs: ",
          error
        );
      }
    };

    const fetchCompanies = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "companies"));
        const companiesData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          name: doc.data().companyName,
        }));
        setCompanies(companiesData);
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des entreprises: ",
          error
        );
      }
    };

    fetchReferentInfo();
    fetchUsers();
    fetchCompanies();
  }, [userId]);

  const handleSearch = (e) => {
    e.preventDefault();
    if (!searchQuery.trim()) {
      setFilteredUsers(users);
      return;
    }
    const queryText = searchQuery.toLowerCase();
    const filtered = users.filter(
      (user) =>
        user.lastName.toLowerCase().includes(queryText) ||
        user.firstName.toLowerCase().includes(queryText) ||
        user.email.toLowerCase().includes(queryText)
    );
    setFilteredUsers(filtered);
  };


  const handleUserClick = (userId, userRole) => {
    if (userId) {
      history.push(`/admin/results?userId=${userId}`);

      /* if (userRole === "referent") {
        history.push(`/admin/list/referent/users?userId=${userId}`);
      } else {
      } */
    }
  };

  return (
    <Container>
      <Row>
        <Col md={1} style={{ display: "flex", flexDirection: "row", gap: 20 }}>
          <i
            className="fa fa-arrow-left"
            aria-hidden="true"
            style={{ cursor: "pointer", fontSize: 24 }}
            onClick={() => history.goBack()}></i>
        </Col>
      </Row>
      <Row className="my-4 align-items-center mt-5">
        <Col md={5} style={{ display: "flex", flexDirection: "row", gap: 20 }}>
          <img
            src={logo}
            alt="Insights"
            className="img-fluid"
            style={{ height: 158 }}
          />
          <div>
            <h1 className="title">
              Référent{" "}
            </h1>
            <span className="subtitle">
              Accèder aux résultats des utilisateurs
            </span>
          </div>
        </Col>
        <Col
          md={6}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}>

          <Form
            inline
            style={{ display: "flex", flex: 1 }}
            onSubmit={handleSearch}>
            <Form.Control
              type="text"
              placeholder="Recherche"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button
              type="submit"
              style={{
                backgroundColor: "rgba(206, 145, 54, 0.36)",
                border: "none",
                borderRadius: "5px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginLeft: "8px",
                padding: "6px 12px",
                color: "#CE9136",
              }}>
              <i
                className="fa fa-search"
                aria-hidden="true"
                style={{ fontSize: 22, color: "#CE9136" }}></i>
            </button>
          </Form>
        </Col>
      </Row>
      <div>
        <span>
          <span style={{ fontWeight: 600 }}>Clients du référent {' '}
            <span style={{ color: "#CE9136" }}>
              {referentInfo?.lastName} {referentInfo?.firstName}
            </span></span>
        </span>
      </div>
      <Row className="mt-4">

        <Col>
          <Card className="card">
            <Card.Body>
              <Form className="mb-4">
                <Row>
                  <Col md={6}>
                    <Form.Group controlId="company">
                      <Form.Label>Entreprise</Form.Label>
                      <Autocomplete
                        suggestions={companies.map((company) => company.name)}
                        placeholder="Sélectionner une entreprise"
                        onSelection={(value) => {
                          const selectedCompany = companies.find(
                            (company) => company.name === value
                          );
                          if (selectedCompany) {
                            setReferentInfo((prev) => ({
                              ...prev,
                              companyId: selectedCompany.id,
                              companyName: selectedCompany.name,
                            }));
                          }
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
              <Table hover>
                <thead>
                  <tr>
                    <th>Utilisateur</th>
                    <th>Nom / Prénom</th>
                    <th>Email</th>
                    <th>Date d'inscription</th>
                    <th>Business unit</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredUsers.map((user) => (
                    <tr key={user.id}>
                      {/*  <td style={{ cursor: "pointer" }} onClick={() => handleUserClick(user.id, user.role)} className="text-center align-middle">
                        <i className="fa fa-user" aria-hidden="true"></i>
                      </td> */}
                      <td
                        className="text-center align-middle"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleUserClick(user.id, user.role)}>
                        <span className="img-conent">
                          <img src={user_iwd} alt="user_iwd" className="icon" />
                        </span>
                      </td>
                      <td>{`${user.lastName} ${user.firstName}`}</td>
                      <td>{user.email}</td>
                      <td>{new Date(user.createdAt).toLocaleDateString()}</td>
                      <td>{user.businessUnit}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default UserReferent;
